import EVENT_NAMES from '../../eventNames';

export default {
  Maximized: new Event(EVENT_NAMES.MAXIMIZED),
  Minimized: new Event(EVENT_NAMES.MINIMIZED),
  ClearAll: new Event(EVENT_NAMES.CLEAR_ALL),
};
